import React, { useCallback, useRef } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { makeStyles } from '@material-ui/core/styles'
import TextField, { MenuProps } from './../../textfield'
import { topBarPopoverOverride } from './../../../application/theme'
import { selectBuilding, selectFloor, selectArea } from './../../../actions/workspace'
import { getBuildings, floorsByBuilding, areasByBuildingFloor } from './../selectors'
import MenuItem from '@material-ui/core/MenuItem'
import Box from '@material-ui/core/Box'
import parser from 'ua-parser-js'

const useStyles = makeStyles(theme => ({
  dropdown: {
    // Width 180 allows 3 dropdowns to fit in the top bar on a medium width screen.
    minWidth: 160
  },
  selectDropdown: {
    cursor: 'initial !important',
    marginRight: '6px'
  },
  // Because we display our popovers in the global portal, we have to style
  // them correctly.
  whiteDropdown: {
    ...topBarPopoverOverride
  }
}))

const Dropdown = ({ isMobile, disabled, value, label, onChange, values }) => {
  const classes = useStyles()
  const container = useRef()

  return (
    <Box className={classes.dropdown}>
      <Box ref={container} />
      <TextField
        select
        margin='none'
        variant='filled'
        fullWidth
        InputProps={{ classes: { root: classes.selectDropdown } }}
        SelectProps={{ MenuProps: { ...MenuProps, PopoverClasses: { paper: classes.whiteDropdown }, container: (isMobile ? null : container.current), disablePortal: true, transformOrigin: { vertical: 0, horizontal: 'left' } } }}
        label={label}
        disabled={disabled}
        value={value}
        onChange={onChange}>
        <MenuItem value={0}><span>All</span></MenuItem>
        {values.map((option, index) => (
          <MenuItem key={`${option.id}-${index}`} value={option.id}>
            <span>{option.name}</span>
          </MenuItem>
        ))}
      </TextField>
    </Box>
  )
}

const Web = ({ selected, disableFilter, buildings, floors, areas, onBuildingSelect, onFloorSelect, onAreaSelect }) => {
  //Get the user's company from the state
  const companyId = useSelector(state => state.auth.companyId)
  const companyType = useSelector(state => {
    const type = state._user.impersonate?.companyType ?? state.auth.payload?.companyType;
    return type;
  });
  // Check if device is mobile
  const isMobile = (parser().device.type === 'mobile' || parser().device.type === 'tablet')

  return (
    <Box display="flex">
      <Dropdown
        label={String(companyType) === '3' ? 'Property' : 'Building'}
        disabled={disableFilter}
        value={selected.building || 0}
        onChange={(e) => onBuildingSelect(e.target.value)}
        values={buildings.sort((a, b) => a.name.localeCompare(b.name))}
        isMobile={isMobile} />
      <Dropdown
        label={String(companyType) === '3' ? 'Block' : 'Floor'}
        disabled={disableFilter || !selected.building}
        value={selected.floor || 0}
        onChange={(e) => onFloorSelect(e.target.value)}
        values={floors.sort((a, b) => a.name.localeCompare(b.name))}
        isMobile={isMobile} />
      <Dropdown
        label={'Area'}
        disabled={disableFilter || !selected.floor}
        value={selected.area || 0}
        onChange={(e) => onAreaSelect(e.target.value)}
        values={areas.sort((a, b) => a.name.localeCompare(b.name))}
        isMobile={isMobile} />
    </Box>
  )
}

export default Web

export const Connected = (props) => {
  const dispatch = useDispatch()

  props = {
    ...props,
    selected: useSelector((state) => state._workspace.selected),
    buildings: useSelector(getBuildings),
    floors: useSelector(floorsByBuilding),
    areas: useSelector(areasByBuildingFloor),
    onBuildingSelect: useCallback((building) => dispatch(selectBuilding(building)), [dispatch]),
    onFloorSelect: useCallback((floor) => dispatch(selectFloor(floor)), [dispatch]),
    onAreaSelect: useCallback((area) => dispatch(selectArea(area)), [dispatch])
  }

  return <Web {...props} />
}
